import { render, staticRenderFns } from "./TransitionPage.vue?vue&type=template&id=c235bd90&scoped=true&"
import script from "./TransitionPage.vue?vue&type=script&lang=ts&"
export * from "./TransitionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c235bd90",
  null
  
)

export default component.exports